<template>
    <div>
		<el-dialog :title="title" :visible.sync="open" width="500px" @close="commitOnClose">
			<el-form ref="saveOrEditForm" :model="saveData" label-width="120px">
				<el-form-item :label="translate('AUTHORITY.NAME')" prop="name">
					<el-input v-model="saveData.name" :placeholder="translate('FROM.PLACEHOLDER', {param: 'AUTHORITY.NAME'})"/>
				</el-form-item>

				<el-form-item :label="translate('COMMON.SORT')" prop="sort">
					<el-input-number v-model="saveData.sort" controls-position="right" :min="0"></el-input-number>
				</el-form-item>

				<el-form-item :label="translate('COMMON.STATUS')">
					<el-radio-group v-model="saveData.status">
						<el-radio v-for="(value,key) in dicts.STATUS" :key="key" :label="key">{{value}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">{{translate('FROM.SUBMIT')}}</el-button>
				<el-button type="primary" @click="cancel">{{translate('FROM.CANCEL')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {UserApi} from '@/api';
	export default {
		name: "CustomForm",
		props: {
			dicts: {
				type: Object,
				default: function () {
					return {}
				}
			},
			isAdd: {
				type: Boolean,
				default: true,
			},
			selectRow: {
				type: Object,
				default: function () {
					return {}
				},
			},
			onFresh: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				title: '',
				saveData: {},
				open: false
			}
		},
		watch: {
			onFresh: function (value) {
				this.open = value;
				if (value) {
					this.resetData();
				}
			}
		},
		mounted() {
		},
		methods: {
			async resetData() {
				if (this.isAdd){
					this.title = this.translate('FROM.ADD_MODULE', {module: 'Role'});
					this.saveData = {};
				}else {
					this.saveData = this.selectRow;
					this.isAdd = false;
					this.title = this.translate('FROM.UPDATE_MODULE', {module: 'Role'});
				}
			},
			async submitForm() {
				let result = (this.isAdd) ? (await UserApi.role.save(this.saveData)) : (await UserApi.role.edit(this.saveData.roleId, this.saveData));
				if (result.success) {
					this.Message.success(this.translate(this.isAdd ? 'FROM.ADD_SUCCESS' : 'FROM.UPDATE_SUCCESS'));
					this.commitOnClose();
				}
			},
			cancel() {
				this.saveData = {};
				this.commitOnClose();
			},
			commitOnClose() {
				this.$emit('on-close');
			}
		}
	};
</script>

<style scoped>

</style>
